import { SparklesIcon } from '@heroicons/react/outline';
import Link from 'next/link';
import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import { Preset } from '@/constants/presets';

interface OtherFeaturesProps {
  presets: Preset[];
}

export default function OtherFeatures({ presets }: OtherFeaturesProps) {
  const { t } = useLocale('tools');

  return (
    <div className='relative bg-white py-16 dark:bg-slate-900 sm:py-24 lg:py-32'>
      <div className='mx-auto max-w-md px-4 text-center sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8'>
        <h2 className='mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          {t('Check out these other templates')}
          <span className='ml-2 text-lg text-primary-500'>
            <Link href='/templates'>{t('See all')} &rarr;</Link>
          </span>
        </h2>
        <div className='mt-12'>
          <div className='grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3'>
            {presets.map((preset, presetIdx) => (
              <div key={presetIdx} className='pt-6'>
                <div className='flow-root rounded-lg bg-gray-50 px-6 pb-8 dark:bg-slate-800'>
                  <div className='-mt-6'>
                    <div>
                      <span
                        className={clsxm(
                          preset.iconBackground,
                          preset.iconForeground,
                          'inline-flex rounded-lg p-3 dark:bg-slate-700'
                        )}
                      >
                        <SparklesIcon className='h-6 w-6 ' aria-hidden='true' />
                      </span>
                    </div>
                    <p className='mt-8 text-lg font-medium tracking-tight text-gray-900 dark:text-slate-200'>
                      <Link
                        href={
                          !preset.isAbsoluteURL
                            ? `/templates/${preset.slug}`
                            : preset.landingPageSlug || preset.slug
                        }
                      >
                        {t(preset.title)}
                      </Link>
                    </p>
                    <p className='mt-5 text-base text-gray-500 dark:text-slate-400'>
                      {t(preset.description)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
